interface HandleZipcodeProps {
  event: React.ChangeEvent<HTMLInputElement>;
  callback: (data: any) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const handleZipcode = ({event, callback, loading, setLoading}: HandleZipcodeProps) => {
  const {value} = event.target;
  const zipcode = (value).replace(/\D/g, '');
  if(zipcode.length == 8 && !loading){
    setLoading(true);
    fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
      .then(response => response.json())
      .then(data => {
        const {bairro : neighborhood, localidade : city, logradouro : street, uf : state} = data;
        callback({neighborhood, city, street, state});
      })
      .finally(() => setLoading(false));
  }
}
export interface EnderecoDoCep {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
}

// Versao usada pelo cadastro. A `handleZipcode` acima continua servindo o
// formulario de filiais do admin; esta trata o que faltava la: CEP inexistente
// (o ViaCEP responde 200 com `erro: true`) e resposta atrasada de um CEP
// anterior, que sobrescrevia o endereco recem-preenchido.
export const lookupZipcode = async (
  zipcode: string,
  {signal}: {signal?: AbortSignal} = {},
): Promise<EnderecoDoCep | null> => {
  const digitos = (zipcode ?? '').replace(/\D/g, '');
  if (digitos.length !== 8) return null;

  const resposta = await fetch(`https://viacep.com.br/ws/${digitos}/json/`, {signal});
  if (!resposta.ok) return null;

  const dados = await resposta.json();
  if (!dados || dados.erro) return null;

  return {
    street: dados.logradouro ?? '',
    neighborhood: dados.bairro ?? '',
    city: dados.localidade ?? '',
    state: dados.uf ?? '',
  };
};
